import React from "react";
import styles from "./Map.module.css";

const Map = () => {
  return (
    <div>
      <iframe
        title="Location"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6004.606732570081!2d73.0306667!3d21.4687703!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be03d0f4ac9ab79%3A0x3eecd961b30ca2c5!2sHetva%20Enterprise!5e1!3m2!1sen!2sin!4v1727529259310!5m2!1sen!2sin"
        style={{ border: "0" }}
        loading="lazy"
        className={`w-full h-80 md:h-96 ${styles.map}`}
      ></iframe>
    </div>
  );
};

export default Map;
